import { AfterViewInit, Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { switchMap, map } from "rxjs/operators";

import { FilterModel } from "app/filter/filter.model";

import { HomeModel } from "../home.model";
import { Patient } from "../../shared/types";
import { SplashScreenService } from "../../shared/modules";
import { FilterPageOptionEnum } from "../../shared/enums/filter-page-option.enum";

@Component({
	templateUrl: "residents.component.html",
	styleUrls: ["residents.component.scss"],
	standalone: false,
})
export class ResidentsComponent implements AfterViewInit, OnInit {
	private readonly homeModel = inject(HomeModel);
	private readonly splashscreenService = inject(SplashScreenService);
	private readonly router = inject(Router);
	private readonly filterModel = inject(FilterModel);

	hasActiveFilters$ = this.homeModel.filter$.pipe(map((filters) => !!filters.length));
	taskFilter$ = this.filterModel.openTasksFilter$;
	patients$ = this.taskFilter$.pipe(
		switchMap((hideResidentsWithoutTasks) =>
			this.homeModel.patients$.pipe(
				map((patients) => {
					if (!hideResidentsWithoutTasks) {
						return patients;
					}

					// @ts-expect-error TS18048
					return patients.filter((patient) => !!patient.openTaskCodes?.length);
				}),
			),
		),
	);

	ngOnInit(): void {
		this.filterModel.selectFilter(FilterPageOptionEnum.RESIDENTS);
	}

	showDetails(patient: Patient) {
		this.router.navigate([patient.id, "overview"]);
	}

	ngAfterViewInit() {
		this.splashscreenService.hide();
	}

	togglePatientWithTasks() {
		this.filterModel.toggleTasksFilter();
	}
}
